// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3rJVO","noInteraction":"EventWrapper_noInteraction__25O8V","pointerPassthrough":"EventWrapper_pointerPassthrough__22g6w"};